module.exports = __webpack_public_path__ + "static/media/43-iveco.998b8cb4.jpg";